<template>
  <div class="video-container">
    <div class="video-box" :class="activated ?'activated':''">
      <div v-if="video.number" class="video-box-con">
        <iframe
          v-if="video.camera_type==1"
          :src="'https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/'+video.number+'/'+video.channel+'.live&autoplay=1&accessToken='+ this.video.access_token"
          width="100%"
          height="100%"
          :id="'video'+video.number"
          allowfullscreen
        >
        </iframe>
        <iframe
          v-else-if="video.camera_type==2"
          :src="'../../../static/lcy_video/webLive.html?url='+video.number+'|kitToken='+video.access_token"
          width="100%"
          height="100%"
          :id="'video'+video.number"
          allowfullscreen
        >
        </iframe>
        <div v-else 
          class="video-in" 
          :id="'video'+video.number"
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { QNRTPlayer } from "qn-rtplayer-web";
import { setTimeout } from "timers"
import cameraApi from "@/api/light/camera";
export default {
  props: {
    video: {
      type: Object,
      required: true,
      default: function () {
        return {
          number: '',
          camera_type: 1,
          channel: 1,
          access_token: ''
        }
      }
    },
    activated: {
      type: Boolean,
      default: function (e) {
        return false
      }
    }
  },
  data() {
    return {
      player: null
    }
  },
  watch: {
    video: {
      handler(newVal) {
        if(newVal){
          if(newVal.number){
            if(newVal.camera_type==3) {
              this.qnyPlayerinit()
            }
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  destroyed() {
    if(this.video.camera_type==3) { 
      this.player = null
      this.qnyStopFlow()
    }
  },
  methods: {
    async qnyPlayerinit() {
      this.player = new QNRTPlayer();
      this.player.init({
        width: '100%',
        height: '100%',
        objectFit: 'contain'
      });
      setTimeout(() => {
        this.streamUrl()
      }, 500);
    },
    async streamUrl() {
      await cameraApi.qnyGetStreamUrl(this.video.number).then((res) => {
        // console.log('streamUrl', res.data.data.playUrls.rtmp)
        if (res.data.code == 1000) {
          this.qnyStartFlow(res.data.data.playUrls.webrtc)
        }
      });
    },
    async qnyStartFlow(url) {
      await cameraApi.qnyFlow(this.video.number, {
        type: 1
      }).then((res) => {
        if (res.data.code === 1000) {
          this.player.play(
            url,
            document.getElementById('video'+this.video.number)
          )
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    qnyStopFlow() {
      cameraApi.qnyFlow(this.video.number, {
        type: 0
      }).then((res) => {
      });
    }
  }
}
</script>
<style lang='less' scoped> 
.video-container{
  width: 100%;
  height: 100%;
  background: #4C4B4B;
  overflow: hidden;
  position: relative;
  float: left;
  .video-box{
    width: 100%;
    height: 100%;
    position: relative;
    border: 2px solid #353535;
    box-sizing: border-box;
    .video-box-con{
      width: 100%;
      height: 100%;
      position: relative;
    }
    &.activated {
      border:2px solid #409eff;
    }
    iframe,.video-in{
      width:100%;
      height:100%;
      padding:0;
      border:0;
      margin:0;
      position: relative;
      pointer-events: none;
    }
  }
}
</style>
